export const AI_WORKFLOW_STEP_KEYS = [
    'aiStep_reading',
    'aiStep_analyzing',
    'aiStep_ingredients',
    'aiStep_prepSteps',
    'aiStep_nutrition',
    'aiStep_allergensDiet',
    'aiStep_saving',
] as const;

export type AiWorkflowStepKey = (typeof AI_WORKFLOW_STEP_KEYS)[number];

export const AI_WORKFLOW_STEP_COUNT = AI_WORKFLOW_STEP_KEYS.length;
export const AI_PARSE_LAST_STEP_INDEX = 3;
